/**
 * Stripe Element styling configuration
 */

export const STRIPE_ELEMENT_STYLES = {
  base: {
    fontSize: '16px',
    color: '#1D1D1D',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontWeight: '300',
    lineHeight: '24px',
    '::placeholder': {
      color: '#808080',
      fontWeight: '300',
    },
  },
  invalid: {
    color: '#EF4444',
  },
};

/**
 * Get Stripe element styles with disabled state
 * @param disabled Whether the element is disabled
 * @returns Stripe element style configuration
 */
export const getStripeElementStyles = (disabled: boolean) => ({
  base: {
    ...STRIPE_ELEMENT_STYLES.base,
    color: disabled ? '#808080' : '#1D1D1D',
  },
  invalid: STRIPE_ELEMENT_STYLES.invalid,
});
